'use client';

import { ChangeEvent } from 'react';
import classes from './qty-input.module.scss';

interface QtyInputProps {
  quantity: number;
  removeFeature?: boolean;
  maxQuantity: number;
  editable?: boolean;
  updateQuantityFn: (
    quantity: number,
    event?: ChangeEvent<HTMLInputElement>,
  ) => void;
  inputValue: string;
  onInputChange: (value: string) => void;
}

const QtyInput = ({
  quantity,
  removeFeature = true,
  maxQuantity = 999,
  editable = true,
  updateQuantityFn,
  inputValue,
  onInputChange,
}: QtyInputProps) => {
  const handleQuantityChange = (
    newQuantity: number,
    event?: ChangeEvent<HTMLInputElement>,
  ) => {
    if (newQuantity >= 0 && newQuantity <= maxQuantity) {
      updateQuantityFn(newQuantity, event);
    }
  };

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onInputChange(e.target.value);
  };

  const handleInputBlur = (e: ChangeEvent<HTMLInputElement>) => {
    const newQuantity = Math.min(
      Math.max(0, Number(e.target.value)),
      maxQuantity,
    );
    if (!isNaN(newQuantity)) {
      handleQuantityChange(newQuantity, e);
    }
  };

  return (
    <div
      className={`${classes['item-qty']} ${!editable ? classes['disabled'] : ''}`}
    >
      <span
        tabIndex={0}
        className={`d-print-none ls-icon ${classes['icn-minus-hvy']} ${classes['update-qty']} ${quantity === 1 && removeFeature ? classes['icn-trash-o'] : quantity === 1 ? classes['disabled-update'] : ''}`}
        onClick={() => handleQuantityChange(quantity - 1)}
      />
      <input
        tabIndex={0}
        type="number"
        min="0"
        max={maxQuantity}
        className={classes['qty-input']}
        value={inputValue}
        onFocus={(e) => e.target.select()}
        onBlur={handleInputBlur}
        onChange={handleInputChange}
        disabled={!editable}
      />
      <span
        tabIndex={0}
        className={`d-print-none ls-icon ${classes['icn-plus-hvy']} ${classes['update-qty']} ${quantity >= maxQuantity ? classes['disabled-update'] : ''}`}
        onClick={() => handleQuantityChange(quantity + 1)}
      />
    </div>
  );
};

export default QtyInput;
